import { FC, memo } from 'react';

import { TEXTS } from './texts';

import styles from './VideoPricePlan.module.scss';

interface VideoPricePlanProps {
  withTitle?: boolean;
}

export const VideoPricePlan: FC<VideoPricePlanProps> = memo(({ withTitle = true }) => (
  <div className={styles.container}>
    {withTitle && <h4>{TEXTS.TITLE}</h4>}

    <div className={styles.row}>
      <div>{TEXTS.ROW1_TITLE}</div>

      <div className={styles.priceContainer}>
        <div>
          <span className={styles.price}>{TEXTS.ROW1_MONTH_PRICE}</span>
          <span>{TEXTS.MONTH_TITLE}</span>
        </div>

        <div>
          <span className={styles.price}>{TEXTS.ROW1_YEAR_PRICE}</span>
          <span>{TEXTS.YEAR_TITLE}</span>
        </div>
      </div>
    </div>

    <div className={styles.row}>
      <div>{TEXTS.ROW2_TITLE}</div>

      <div className={styles.priceContainer}>
        <div>
          <span className={styles.price}>{TEXTS.ROW2_MONTH_PRICE}</span>
          <span>{TEXTS.MONTH_TITLE}</span>
        </div>

        <div>
          <span className={styles.price}>{TEXTS.ROW2_YEAR_PRICE}</span>
          <span>{TEXTS.YEAR_TITLE}</span>
        </div>
      </div>
    </div>

    <div className={styles.row}>
      <div>{TEXTS.ROW3_TITLE}</div>

      <div className={styles.priceContainer}>
        <div>
          <span className={styles.price}>{TEXTS.ROW3_MONTH_PRICE}</span>
          <span>{TEXTS.MONTH_TITLE}</span>
        </div>

        <div>
          <span className={styles.price}>{TEXTS.ROW3_YEAR_PRICE}</span>
          <span>{TEXTS.YEAR_TITLE}</span>
        </div>
      </div>
    </div>
  </div>
));
